module.exports = "/_next/static/images/ba04672a78539d1176be79b9a86daca0-hero-desktop.jpg";